var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isStart)?_c('ElButton',{staticClass:"green",attrs:{"link":""},on:{"click":_vm.handlStart}},[_vm._v(" "+_vm._s(_vm.isRetry ? _vm.endText : _vm.startText)+" ")]):_c('ElButton',{staticClass:"green",attrs:{"link":""}},[_vm._v(" "+_vm._s(_vm.second_text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }